import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fbjcb6vrpzx0">
      <div className="min-h-screen flex flex-col w-full" data-id="element-1" data-mp="3fb19frelong4">
        <Nav data-id="element-2" data-mp="2rkdtciuj6rih" />
        <main className="flex-grow flex flex-col" data-id="element-3" data-mp="2rlypue0eokiz">
          <Routes data-id="element-4" data-mp="2riklx1c3g39f">
            <Route path="/" element={<Home data-id="element-6" data-mp="2mmvlyww5wkcl" />} data-id="element-5" data-mp="2mm2ji848kh09" />
            <Route path="/about" element={<AboutPage data-id="element-8" data-mp="2mjzplczyq3q9" />} data-id="element-7" data-mp="2mndmw6trrmqu" />
            <Route path="/contact" element={<ContactPage data-id="element-10" data-mp="31c9vc4zqn1rz" />} data-id="element-9" data-mp="31b8gdpflpv4z" />
          </Routes>
        </main>
        <Footer data-id="element-11" data-mp="2wjgp1comflds" />
      </div>
    </BrowserRouter>;
}